import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../../../app/hooks";
import { useScrollToSection } from "../../../../app/useScrollToSection";
import { getParamAsInt } from "../../../../app/utils";
import { SelectDevelopmentView } from "../../../../components/input/SelectDevelopmentView";
import RtkqResultViewer from "../../../../components/RtkqResultViewer";
import { Loading } from "../../../../components/Loading";
import EssayDraftHistory from "./essayDraftHistory/EssayDraftHistory";
import { MonthlyScoresChartWithFilters } from "./MonthlyScoresChartWithFilters";
import { useStudentProgressReportQuery } from "./progressReportApiSlice";

export const STUDENT_AVERAGE_MONTHLY_SCORES = "average-monthly-scores";

export default function StudentProgressReport() {
	const [queryParams] = useSearchParams();
	const writerIdQueryParam = getParamAsInt(queryParams, "writerId");
	const courseIdQueryParam = getParamAsInt(queryParams, "courseId");

	const { userId, course } = useAppSelector((state) => state.user);

	const writerId = writerIdQueryParam ?? userId!;
	const courseId = courseIdQueryParam ?? course!.id;

	const [view, setView] = useState<string>("react");

	const result = useStudentProgressReportQuery({ writerId, courseId });
	const data = result.data;

	useScrollToSection();

	return (
		<section>
			<div className="flex justify-between">
				<div className="w-3/4">
					<h1>Progress Report</h1>
				</div>
				<SelectDevelopmentView
					value={view}
					setValue={(v) => setView(v as string)}
					simpleListBoxId="viewFilter"
				/>
			</div>
			{view == "react" && (
				<div>
					<section id={STUDENT_AVERAGE_MONTHLY_SCORES} className="pt-4">
						<h2>Average Monthly Scores</h2>
						<p className="mt-4">
							The graph below displays your average holistic score for the current
							school year by month. Use the drop-down menus to display monthly
							progress for a specific category. Advanced filtering options display
							scores for first drafts, last drafts, or both. Please note scores for
							constructed response are not included.
						</p>
						<Loading loading={result.isLoading} />
						{data && (
							<MonthlyScoresChartWithFilters
								className="mt-8"
								data={data}
								courseId={courseId}
								writerId={writerId}
							/>
						)}
					</section>
					<EssayDraftHistory courseId={courseId} writerId={writerId} />
				</div>
			)}
			{view == "raw" && (
				<>
					<RtkqResultViewer heading="Progress Report Data" result={result} />
				</>
			)}
		</section>
	);
}
